import React from "react";
import { Sparkles, LogIn, X, UserPlus } from "lucide-react";

// Thin persistent bar shown at the very top when the user is exploring in demo mode.
export default function DemoBanner({ onSignup, onExit }) {
  return (
    <div
      data-testid="demo-banner"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: "linear-gradient(90deg, rgba(251,191,36,0.14) 0%, rgba(167,139,250,0.14) 100%)",
        borderBottom: "1px solid rgba(251,191,36,0.35)",
        color: "#fef3c7",
        fontSize: 11.5,
        letterSpacing: "0.08em",
        padding: "6px 14px",
        display: "flex",
        alignItems: "center",
        gap: 12,
        backdropFilter: "blur(8px)",
      }}
    >
      <Sparkles size={12} className="text-[#fbbf24] flex-shrink-0" />
      <span className="mono uppercase tracking-[0.22em] hidden sm:inline">
        Demo mode
      </span>
      <span className="text-white/85 flex-1 truncate">
        You&apos;re exploring HEXA OS with a temporary preview identity. Sign up to save your work &amp; unlock all features.
      </span>
      <button
        data-testid="demo-banner-signup"
        onClick={onSignup}
        className="flex items-center gap-1.5 px-3 py-1 rounded mono text-[10px] uppercase tracking-widest font-medium transition"
        style={{
          background: "rgba(251,191,36,0.9)",
          color: "#0c1224",
          border: "1px solid rgba(251,191,36,1)",
        }}
      >
        <UserPlus size={11} /> Sign up free
      </button>
      <button
        data-testid="demo-banner-login"
        onClick={onSignup}
        className="hidden md:flex items-center gap-1.5 px-3 py-1 rounded mono text-[10px] uppercase tracking-widest text-white/80 hover:text-white transition"
        style={{ border: "1px solid rgba(255,255,255,0.2)" }}
      >
        <LogIn size={11} /> Log in
      </button>
      <button
        data-testid="demo-banner-exit"
        onClick={onExit}
        title="Exit demo"
        className="text-white/70 hover:text-white p-1"
      >
        <X size={12} />
      </button>
    </div>
  );
}
